import { supabase } from "@/integrations/supabase/client";

/** Neçə saniyəyə qədər "son görülmə" onlayn sayılır. */
export const ONLINE_WINDOW_MS = 90_000;

export function isOnline(lastSeen?: string | null): boolean {
  if (!lastSeen) return false;
  return Date.now() - new Date(lastSeen).getTime() < ONLINE_WINDOW_MS;
}

/** Cari istifadəçinin "onlayn" vaxtını yeniləyir (səssiz). */
export async function touchPresence() {
  await supabase.rpc("touch_presence").then(
    () => undefined,
    () => undefined,
  );
}

/** Bir neçə istifadəçinin son görülmə vaxtını gətirir. */
export async function fetchPresence(ids: string[]): Promise<Record<string, string | null>> {
  if (!ids.length) return {};
  const { data, error } = await supabase.rpc("presence_of", { _ids: ids });
  if (error) return {};
  const map: Record<string, string | null> = {};
  for (const r of (data ?? []) as { id: string; last_seen_at: string | null }[]) {
    map[r.id] = r.last_seen_at;
  }
  return map;
}
